module.exports = __webpack_public_path__ + "img/book-circle-arrow-up.66da31df.svg";